module.exports = __webpack_public_path__ + "img/pill.3c4552b1.svg";